import { combineReducers } from "@reduxjs/toolkit";
import categories from "./categories";
import backlinks from "./backlinks";
import orders from "./orders";
import mails from "./mails";

export default combineReducers({
  categories,
  backlinks,
  orders,
  mails
});
